export default __webpack_public_path__ + "static/media/_scotland.da57855a.ico";